<!-- eslint-disable vue/no-mutating-props -->
<template>
    <div>
        <div class="content-residual">
            <!-- Data -->
            <div class="select-date">
                <!-- Data - opções de data -->
                <ui-select-v2
                    v-model="data.date"
                    :data="proposalDatesFilter"
                    item-label="label"
                    return-value="value"
                    label="Data"
                    :class="{'mont-diff': isMonthDiff}"
                    @input="updateItem"
                />

                <!-- Data - quantidade de meses -->
                <ui-input-number-stepper
                    v-if="isMonthDiff"
                    v-model="data.quantity_months"
                    :focus="true"
                    size="sm"
                    class="input-quantity-months"
                    placeholder="Meses"
                    :minValue="-Infinity"
                    :error="monthDiffValidation"
                    @input="updateItem"
                />
            </div>

            <!-- Dia do mês -->
            <ui-input
                v-model="data.days_of_the_month"
                class="input-quantity-days"
                label="Especificar Dia"
				@blur="handleDayInput"
            />

            <!-- Parcela usada de referente -->
            <ui-select-v2
                v-model="data.installment_ref"
                :data="installmentRefSelf"
                item-label="label"
                return-value="value"
                class="select-intallment-ref"
                label="Parcela de Referência"
				:disabled="installmentRefSelf?.length === 0"
                @input="updateItem"
            />
        </div>
    </div>
</template>

<script>
/* eslint-disable vue/no-mutating-props */
import { uiInput, uiSelectV2, uiInputNumberStepper } from '@/components/ui/form'

export default {
	name: 'config-dates-proposal-residual',

	components: {
		uiInput,
		uiSelectV2,
		uiInputNumberStepper,
	},

	props: {
		proposalDatesOptions: {
			type: Array,
			default: () => [],
		},
		data: {
			type: Object,
			default: () => {},
		},
		installmentList: {
			type: Array,
			default: () => [],
		},
		parcelOptions: {
			type: Array,
			default: () => [],
		},
	},

	data() {
		return {
			isMonth: true,
			proposalDatesFilter: [],
			error: false,
		}
	},

	computed: {
		isMonthDiff() {
			return this.data.date === 'month_diff'
		},
        monthDiffValidation(){
            return this.isMonthDiff && (this.data.quantity_months === 0)
        },
		installmentRefSelf() {
			const selectedInstallments = this.installmentList.map((item) => {
				return item.type
			})

			const filteredOptions = this.parcelOptions.filter((option) =>
				selectedInstallments.includes(option.value)
			)

			return filteredOptions
		},
	},

	mounted() {
		// A data de resíduo não tem a opção "data da parcela"
		this.proposalDatesFilter = this.proposalDatesOptions.filter(
			(item) => item.value !== 'installment_date'
		)
	},

  methods: {
    updateItem() {
		this.$emit('update-residue-date')
	},

	handleDayInput(value) {
	    // Remove qualquer letra do valor (mantém apenas números)
	    let onlyNumbers = value.replace(/\D/g, '');
	
	    // Se ficou vazio, define como 0
	    if (onlyNumbers === '') {
	        onlyNumbers = '0';
	    }
	
	    // Corrige o valor para o dia do mês
	    const correctedValue = this.correctDayOfMonth(onlyNumbers);
	
	    // Atualiza dinamicamente o campo
	    this.data.days_of_the_month = correctedValue;
	
	    this.updateItem();
	},

	correctDayOfMonth(day) {
		if (!day) return day;

		const today = new Date();
		const year = today.getFullYear();
		const month = today.getMonth(); // mês atual (0-11)

		const lastDayOfMonth = new Date(year, month + 1, 0).getDate();

		if (day > lastDayOfMonth) {
			return lastDayOfMonth;
		}
		return day;
	},

  }
}
</script>

<style lang="stylus" scoped>
@import './styles.styl'
</style>
